import type { CSSProperties } from 'react';

/**
 * Color utilities for tenant and cloud provider branding
 */

export const CLOUD_PROVIDER_COLORS = {
  aws: '#f59e0b',      // Amber
  hetzner: '#991b1b',  // Dark red
  oci: '#f87171',      // Light red
} as const;

export function getCloudProviderColor(provider: 'aws' | 'hetzner' | 'oci'): string {
  return CLOUD_PROVIDER_COLORS[provider] || '#6b7280'; // Default gray
}

export function getTenantColor(tenant: { color?: string | null }): string {
  return tenant.color || '#6b7280'; // Default gray
}

export type StreamLeafCardUnsetStyle = 'accent' | 'neutral';

/**
 * Leaf card surface from stream YAML `color`.
 * - `accent` (org chart): default violet when unset.
 * - `neutral` (grid): gray/white when unset — custom `streamColor` tints only when the caller passes it (e.g. hierarchy-leaf roles only).
 */
export function streamLeafCardSurface(
  streamColor?: string | null,
  unsetVariant: StreamLeafCardUnsetStyle = 'accent',
): {
  className: string;
  style?: CSSProperties;
} {
  const c = typeof streamColor === 'string' ? streamColor.trim() : '';
  if (!c) {
    if (unsetVariant === 'neutral') {
      return {
        className: 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900',
      };
    }
    return {
      className:
        'border-violet-200/90 bg-violet-50/95 shadow-sm dark:border-violet-700/55 dark:bg-violet-950/35',
    };
  }
  return {
    className: 'border-2 shadow-sm',
    style: {
      borderColor: c,
      backgroundColor: `color-mix(in srgb, ${c} 16%, transparent)`,
    },
  };
}

